export default __webpack_public_path__ + "static/media/oop.e20b3492.jpeg";